import {Component, ComponentRef, OnInit, ViewContainerRef} from '@angular/core';
import {NotificationService} from "../notification.service";
import {NotificationComponent} from "../notification.component";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";

@UntilDestroy()
@Component({
  selector: 'brt-notifications-container',
  templateUrl: './notifications-container.component.html',
  styleUrls: ['./notifications-container.component.scss']
})
export class NotificationsContainerComponent implements OnInit{

  notificationLifeTime = 3000;
  currentNotification: ComponentRef<NotificationComponent> | null = null;
  constructor(private containerRef: ViewContainerRef, private notificationsService: NotificationService) {
  }

  ngOnInit() {
    this.notificationsService.onNotificationPushed().pipe(untilDestroyed(this)).subscribe((data) => {

      if(this.currentNotification !== null) {
        const oldNotification = this.currentNotification;
        this.currentNotification = null;
        oldNotification.instance.isVisible = false;
        setTimeout(() => {
          oldNotification.destroy();
        }, 500);
      }
      const newNotification = this.containerRef.createComponent(NotificationComponent);
      newNotification.setInput("data", data);
      newNotification.changeDetectorRef.detectChanges();
      this.placeAboveTopLayerOverlays(newNotification);
      this.currentNotification = newNotification;

      setTimeout(() => {
        if(newNotification.instance.isVisible) {
          newNotification.instance.isVisible = false;

          setTimeout(() => {
            newNotification.destroy();
          }, 1000);
        }
      }, this.notificationLifeTime);


    });
  }

  /**
   * Overlay windows (OverlayWindowComponent) use a native `<dialog>.showModal()`, which renders in
   * the browser's top layer — above all normal-flow content regardless of z-index. A toast left in
   * the page body therefore ends up *behind* an open overlay. To stay visible, re-parent it into the
   * topmost open modal `<dialog>`, where it shares that top-layer context and its z-index wins again.
   * The toast keeps its fixed, viewport-anchored position because these dialogs carry no transform.
   * With no modal dialog open it stays where Angular placed it (normal z-index behaviour is enough).
   */
  private placeAboveTopLayerOverlays(ref: ComponentRef<NotificationComponent>): void {
    const modalDialogs = Array.from(document.querySelectorAll('dialog[open]'))
      .filter((dialog): dialog is HTMLDialogElement => {
        try {
          return dialog.matches(':modal');
        } catch {
          return false;
        }
      });
    const topDialog = modalDialogs[modalDialogs.length - 1];
    if (topDialog) {
      topDialog.appendChild(ref.location.nativeElement);
    }
  }

}
